"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cumulativeLayoutShift = void 0;
var _attribution = require("web-vitals/attribution");
var _constants = require("./constants");
var _vitalMetric = require("./vital-metric");
var _runtime = require("../constants/runtime");
const cumulativeLayoutShift = exports.cumulativeLayoutShift = new _vitalMetric.VitalMetric(_constants.VITAL_NAMES.CUMULATIVE_LAYOUT_SHIFT, x => x);
if (_runtime.isBrowserScope) {
  (0, _attribution.onCLS)(({
    value,
    attribution,
    id
  }) => {
    const attrs = {
      metricId: id,
      largestShiftTarget: attribution.largestShiftTarget,
      largestShiftTime: attribution.largestShiftTime,
      largestShiftValue: attribution.largestShiftValue,
      loadState: attribution.loadState
    };
    cumulativeLayoutShift.update({
      value,
      attrs
    });
  }, {
    reportAllChanges: true
  });
}